import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AgentTableComponent } from './agent-table/agent-table.component';
import { AddEditAgentComponent } from './add-edit-agent/add-edit-agent.component';

const  routes: Routes = [
  {
    path: "",
    component: AgentTableComponent,
  },
  {
    path: "add",
    component: AddEditAgentComponent,
  },
  {
    path: "edit/:id",
    component: AddEditAgentComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AgentRoutingModule {}
